import { decrypt, encrypt } from '@/utils/gcm';
import { clearUserData, getUserData } from '@/utils/user';
import { history } from '@@/core/history';
import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message } from 'antd';

const enableEncrypt = false;

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    errorHandler: (error: any) => {
      console.debug(error);
      const errorMessage = error.response?.data?.error ?? error.message;
      message.error(errorMessage);
      if (error.response.data.code === 4013) {
        clearUserData();
        history.replace({
          pathname: '/user/login',
        });
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    async (config: RequestOptions) => {
      config.url = `${(window as any).API_BASE_URL}/${config.url}`;

      if (config.params?.current) {
        config.params.page = config.params.current;
        delete config.params.current;
      }
      if (config.params?.pageSize) {
        config.params.limit = config.params.pageSize;
        delete config.params.pageSize;
      }

      // 处理ngrok警告 - 在所有环境下都设置
      (config.headers as any)['ngrok-skip-browser-warning'] = 'true';

      if (enableEncrypt && config.data) {
        config.headers = {
          ...config.headers,
          'Content-Type': 'text/plain;charset=UTF-8',
        };
        config.data = await encrypt(config.data);
      }

      const userData = getUserData();

      config.headers = config.headers ?? {};

      if (userData && userData.accessToken) {
        config.headers.Authorization = `Bearer ${userData.accessToken}`;
      }
      return { ...config };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    async (response: any) => {
      let data = response.data;
      if (enableEncrypt) {
        data = await decrypt(response.data);
      }
      if (process.env.NODE_ENV === 'development') {
        console.debug(response.request.responseURL, data?.data);
      }
      response.data = data;
      if (data.code !== 1000) {
        throw {
          response,
        };
      }
      if (response.data?.data?.total) {
        response.data.total = response.data.data.total;
      }
      if (response.data?.data?.lines) {
        response.data.data = response.data.data.lines;
      }
      return response;
    },
  ],
};
